var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.menus.length > 0
    ? _c(
        "div",
        { staticClass: "user_memorandum_menus" },
        _vm._l(_vm.menus, function (itm) {
          return _c("menu_item", { key: itm.id, attrs: { item: itm } })
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }